import "@sms/design-system/tokens/global.css";

// Standalone entry — used when developers run `pnpm dev` in this
// directory without the shell host, and when parents open
// parent.<your-domain> directly. The shell consumes the federated
// <TodayWidget /> export and supplies its own providers; do not put
// global side effects here that would also affect the shell-hosted
// path.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { TodayWidget } from "./features/today/TodayWidget";
import { attachServiceWorkerListener } from "./sw-listen";
import { registerParentAppSW } from "./sw-register";

const root = document.getElementById("root");
if (!root) throw new Error("parent-app: #root missing in index.html");

createRoot(root).render(
  <StrictMode>
    <TodayWidget locale="ne" />
  </StrictMode>,
);

// Register the service worker so push notifications can be received
// when the parent-app is "Added to Home Screen". registerParentAppSW
// no-ops outside production builds + browser environments, and is
// idempotent across calls.
window.addEventListener("load", () => {
  void registerParentAppSW();
});

// Bridge SW `push` broadcasts into a window CustomEvent so InboxView
// (and any future subscriber) can refetch without knowing about the
// SW message channel. Phase 3 of NOTICE_DELIVERY_PLAN.md. Safe to
// call in dev — listener attaches but never fires.
attachServiceWorkerListener();
